import map from 'lodash/map';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import Label from '@spothero/ui/label';
import Select from '@spothero/ui/select';
import APIUtils from '@spothero/utils/api';
import VehicleAPI from 'api/vehicle';

class VehicleColorSelect extends Component {
    static propTypes = {
        useLabels: PropTypes.bool,
        vehicleColor: PropTypes.string,
    };
    static defaultProps = {
        useLabels: true,
    };
    state = {
        colorOptions: [],
    };

    componentDidMount() {
        this._getColorOptions();
    }

    componentWillUnmount() {
        if (this._colorOptionLoader) {
            this._colorOptionLoader.cancel();
            this._colorOptionLoader = null;
        }
    }

    async _getColorOptions() {
        const {useLabels} = this.props;
        let colorOptions = [];

        try {
            this._colorOptionLoader = APIUtils.makeCancelable(
                VehicleAPI.getColorOptions()
            );

            const {
                data: {
                    data: {results},
                },
            } = await this._colorOptionLoader.promise;

            colorOptions = map(results, ({name, value}) => {
                return {
                    value: name,
                    label: value,
                };
            });
        } catch (error) {
            // colors didnt load :(
        }

        colorOptions.unshift({
            value: '',
            label: useLabels ? '----------' : 'Vehicle Color',
        });

        colorOptions.push({
            value: 'Unknown',
            label: 'Unknown',
        });

        if (this._colorOptionLoader) {
            this.setState({
                colorOptions,
            });
        }

        this._colorOptionLoader = null;
    }

    submit() {
        return this._vehicleColorSelect.submit();
    }

    render() {
        const {useLabels, vehicleColor} = this.props;
        const {colorOptions} = this.state;

        return (
            <div className="VehicleColorSelect">
                <Form
                    ref={node => {
                        this._vehicleColorSelect = node;
                    }}
                    id="VehicleColorSelect-form"
                >
                    <Select
                        label={useLabels ? <Label>Vehicle Color</Label> : null}
                        className="VehicleSelect-color"
                        name="vehicleColor"
                        defaultValue={vehicleColor}
                        items={colorOptions}
                        error={
                            <FormElementError>
                                Please select a color.
                            </FormElementError>
                        }
                        required
                    />
                </Form>
            </div>
        );
    }
}

export default VehicleColorSelect;
